import script from "./ElementOpacity.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementOpacity.vue?vue&type=script&lang=ts&setup=true"

import "./ElementOpacity.vue?vue&type=style&index=0&id=03715c20&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03715c20"]])

export default __exports__